<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%">
        <v-form v-model="valid" id="valid" ref="formIncidencia">
          <v-flex lg12 pa-5>
            <v-row no-gutters style="float: right;padding-right: 20px;">
              <v-checkbox
                :disabled="rolCliente || rolProveedor"
                id="evaluado"
                v-model="noEvaluado"
                style="margin-top: 0px !important;"
                color="primary"
                :label="localization.noEvaluado"
                @change="updateCambiado(true)"
              />
            </v-row>
            <!--<o-big-title justify="start">{{ (localization.title + ' ' + incidencia.id) }}</o-big-title>-->
            <o-big-title justify="start">{{ (localization.title + ' ' + incidencia.referencia + " ("+$t('m_visita')+" "+incidencia.visitaReferencia+")") }}</o-big-title>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row dense justify="start">
                  <v-col  >
                    <v-text-field
                      :disabled="rolCliente || rolProveedor"
                      v-model="getTraduccionTipo"
                      id="tipoSolicitud"
                      :label="localization.tipoSolicitud"
                      readonly
                      @change="updateCambiado(true)"
                    />
                  </v-col>
                  <v-col align-self="center" cols="1" class="pl-4">
                    <v-btn color="primary" @click="cambiarTipoSolicitud(incidencia)" :disabled="comprobarDeshabilitarCambioTipo()" v-if="!rolProveedor && !rolCliente">
                      <v-icon >import_export</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="origenAltaComprobado"
                      id="origenAltaComprobado"
                      :disabled="rolCliente || rolProveedor"
                      :label="localization.origenAlta"
                      readonly
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      :disabled="rolCliente || rolProveedor"
                      v-model="getTraduccionEstado"
                      id="estado"
                      :label="localization.estado"
                      readonly
                      @change="updateCambiado(true)"
                    />
                  </v-col>
                  <v-col align-self="center" cols="2" class="pl-4">
                    <v-btn color="primary" @click="modifyState(incidencia)" v-if="(!rolCliente && !rolProveedor) || this.permitirModificarEstado() ">
                      {{localization.estadoButton}}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="incidencia.codigoTipoSolicitud === '1'">
                <v-row dense justify="start">
                  <v-col cols="3">
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.tipoParteId"
                      id="tipoParteId"
                      :items="tiposDeParte"
                      :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || ''  }`"
                      item-value="id"
                      sort-by="code"
                      :label="textoCampoComprobarObligatorio(localization.tipoParte, 'Parte')"
                      clearable
                      @change="updateCambiado(true)"
                      :rules="(comprobarObligatorio('Parte') && getterOrderTypes.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.urgenciaId"
                      id="urgenciaId"
                      :items="getterUrgencias"
                      :label="textoCampoComprobarObligatorio(localization.urgencia, 'Urgencia')"
                      :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
                      item-value="value"
                      clearable
                      @change="updateCambiado(true)"
                      :rules="(comprobarObligatorio('Urgencia') && getterUrgencias.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.complaint"
                      id="complaint"
                      :items="tiposDeReclamacion"
                      :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || '' }`"
                      item-value="id"
                      sort-by="code"
                      clearable
                      :label="textoCampoComprobarObligatorio(localization.tipoReclamacion, 'Tipo Reclamación')"
                      multiple
                      :loading="cargandoReclamaciones && !rolProveedor"
                      @change="updateCambiado(true)"
                      :rules="(comprobarObligatorio('Tipo Reclamación') && getterComplaintTypes.length !== 0 && comprobar) ? [rules.required] : []"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="incidencia.codigoTipoSolicitud === '1'">
                <v-row dense align-content="center">
                  <v-col>
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      :disabled="rolCliente || rolProveedor || esInmuebleEspecial()"
                      v-model="incidencia.estanciaId"
                      id="estanciaId"
                      :items="localizaciones"
                      :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : item.name || ''  }`"
                      item-value="id"
                      sort-by="code"
                      :label="incidencia.inmuebleEspecialPromocionId ? 'Localización' : textoCampoComprobarObligatorio(localization.localizacion, 'Localización')"
                      clearable
                      @change="updateCambiado(true)"
                      :rules="(!incidencia.inmuebleEspecialPromocionId && comprobarObligatorio('Localización') && getterLocalizaciones.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      :disabled="rolCliente || rolProveedor && !permisosExtraProveedor"
                      v-model="incidencia.oficioId"
                      id="oficioId"
                      :items="oficios"
                      :item-text="mostrarIdioma"
                      item-value="value"
                      sort-by="code"
                      clearable
                      @click:clear="$nextTick(() => incidencia.oficioId = null)"
                      :label="textoCampoComprobarObligatorio(localization.oficio, 'Oficio')"
                      @change="changeOficio()"
                      :rules="(comprobarObligatorio('Oficio') && getterOficios.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      v-model="incidencia.suboficioId"
                      id="suboficioId"
                      :items="suboficios"
                      :item-text="mostrarIdioma"
                      sort-by="code"
                      :label="textoCampoComprobarObligatorio(localization.suboficio, 'Suboficio')"
                      :disabled="incidencia.oficioId === null || rolCliente || rolProveedor && !permisosExtraProveedor"
                      clearable
                      @click:clear="$nextTick(() => incidencia.suboficioId = null)"
                      @change="updateCambiado(true); vaciaIncidenciaPredefinida();"
                      :rules="(comprobarObligatorio('Suboficio') && getterSuboficios.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                  <v-col v-if="incidencia.codigoTipoSolicitud === '1'">
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')"
                      v-model="incidencia.incidenciaPredefinidaId"
                      id="incidenciaPredefinidaId"
                      :items="incidenciasPredefinidas"
                      :item-text="mostrarIdioma"
                      item-value="id"
                      sort-by="code"
                      clearable
                      :label="textoCampoComprobarObligatorio(localization.predefinida, 'Predefinida')"
                      :disabled="incidencia.oficioId === null || rolCliente || rolProveedor"
                      @change="updateCambiado(true)"
                      :rules="(comprobarObligatorio('Predefinida') && getterPredefinedIncidencesByProfession.length !== 0 && incidencia.oficioId != null) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col>
                    <v-textarea
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.descripcion"
                      id="descripcion"
                      rows="3"
                      row-height="15"
                      :label="textoCampoComprobarObligatorio(localization.descripcion, 'Descripción')"
                      @change="updateCambiado(true)"
                      :rules="comprobarObligatorio('Descripción') ? [rules.obligatorio] : []"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col>
                    <v-textarea
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.observaciones"
                      id="observaciones"
                      rows="3"
                      row-height="15"
                      :label="localization.observaciones"
                      @change="updateCambiado(true)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="3">
                    <v-checkbox
                      :disabled="rolCliente || rolProveedor"
                      id="reincidente"
                      v-model="reincidente"
                      style="margin-top: 0px !important"
                      :value="reincidente"
                      color="primary"
                      :label="localization.reincidente"
                      @change="marcarReincidente($event); updateCambiado(true)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      :disabled="true"
                      style="margin-top: 0px !important"
                      :value="reabierta"
                      id="reaabierta"
                      v-model="reabierta"
                      color="primary"
                      :label="localization.reabrirIncidencia"
                      @change="reabrirIncidencia($event)"
                    />
                  </v-col>
                  <v-col cols="6">
                    &nbsp;
                  </v-col>
                  <v-col cols="3" v-if="(!rolCliente || rolCliente && ocultarResponsable === false)">
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')" 
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.responsableId"
                      id="responsableId"
                      :items="responsables"
                      item-text="nombreCompleto"
                      item-value="id"
                      :label="textoCampoComprobarObligatorio(localization.responsable, 'Responsable')"
                      clearable
                      @change="updateCambiado(true)"
                      :rules="(comprobarObligatorio('Responsable') && responsables.length !== 0) ? [rules.obligatorio] : []"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <o-big-title justify="start" v-if="incidencia.codigoTipoSolicitud === '1' && (!rolCliente || rolCliente && ocultarProveedorHoras === false)">{{ (localization.proveedor) }}</o-big-title>
            <v-row no-gutters v-if="incidencia.codigoTipoSolicitud === '1' && (!rolCliente || rolCliente && ocultarProveedorHoras === false)">
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="4">
                    <v-autocomplete
                      :no-data-text="$t('sinDatos')" v-model="incidencia.proveedorId"
                      id="proveedorId"
                      :disabled="rolCliente || rolProveedor"
                      :label="localization.proveedor" item-value="id"
                      :items="proveedores" clearable
                      item-text="nombreCompleto"
                      single-line
                      sort-by="code"
                      @change="updateCambiado(true)">
                        <template v-slot:selection="data">
                          {{ data.item.code }} - {{ data.item.name }}
                        </template>
                        <template v-slot:item="data">
                          {{ data.item.code }} - {{ data.item.name }}
                        </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2" xl="1">
                    <o-numeric-text-field
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.horas"
                      id="horas"
                      :label="localization.horas"
                      :precision="true"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <o-big-title justify="start">{{ (localization.fechas) }}</o-big-title>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaAviso"
                      id="fechaAviso"
                      :label="localization.fechaAviso"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaFinPrevisto"
                      id="fechaFinPrevisto"
                      :label="localization.fechaFinPrevisto"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaFinReal"
                      id="fechaFinReal"
                      :label="localization.fechaFinReal"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaReapertura"
                      id="fechaReapertura"
                      :label="localization.reapertura"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col v-if="incidencia.codigoTipoSolicitud === '1'" cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaRespuestaObra"
                      id="fechaRespuestaObra"
                      :label="localization.fechaRespuestaObra"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaNotificacionFinPrevisto"
                      id="fechaNotificacionFinPrevisto"
                      :label="textoCampoComprobarObligatorio(localization.fechaNotificacionFin, 'Fin Previsto')"
                      :obligatorio="comprobarObligatorio('Fin Previsto')"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaNotificacionFinReal"
                      id="fechaNotificacionFinReal"
                      :label="localization.fechaNotificacionFinReal"
                    />
                  </v-col>
                  <v-col cols="3">
                    <o-date-picker
                      :disabled="rolCliente || rolProveedor"
                      v-model="incidencia.fechaNotificacionRechazo"
                      id="fechaNotificacionRechazo"
                      :label="localization.fechaNotificacionRechazo"
                    />
                  </v-col>
                </v-row>
                <v-row dense align="center">
                  <v-col cols="4" xl="1">
                    <v-checkbox
                      :disabled="true"
                      v-model="incidencia.Revisada"
                      id="revisada"
                      color="primary"
                      :label="localization.revisada"
                      @change="updateCambiado(true)"
                    />
                  </v-col>
                  <v-col>
                    <o-date-picker
                      :disabled="true"
                      v-model="incidencia.fechaRevision"
                      id="fechaRevision"
                      :label="localization.fechaRevision"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-flex>
        </v-form>
      </v-card>
    </v-layout>
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarCambiarEstado"
        v-model="mostrarCambiarEstado"
        id="mostrarCambiarEstado"
        @aceptar="mostrarCambiarEstado = $event"
      >
        <PopUpCambiarEstado
          :singleItem="singleItem"
          :estadoOrigen="estadoOrigen"
          @updateData="setNuevoEstado($event)"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog
        v-if="dialogCambiarTipo"
        v-model="dialogCambiarTipo"
        id="dialogCambiarTipo"
        @aceptar="dialogCambiarTipo = $event"
      >
        <PopUpCambiarTipo
          :solicitud="solicitudTipo"
          @updateData="setNuevoTipo($event)"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PopUpCambiarEstado from '../formularios/PopUpCambiarEstado'
import rulesMixin from '@/components/generic/rules.js'
import PopUpCambiarTipo from '../formularios/PopUpCambiarTipo'

export default {
  mixins: [rulesMixin],
  components: {
    PopUpCambiarEstado,
    PopUpCambiarTipo
  },
  props: {
    incidencia: {}
  },
  data () {
    return {
      valid: true,
      dialog: false,
      singleItem: [],
      horas: '',
      incidenciaComp: {},
      selectedLocation: [],
      estadoOrigen: '0',
      mostrarCambiarEstado: false,
      tipoSolicitudSelected: '',
      comprobar: false,
      cargandoReclamaciones: true,
      dialogCambiarTipo: false,
      solicitudTipo:{}
    }
  },
  computed: {
    ...mapGetters({
      getProvidersByPropDevAndProf: 'incidencias/getProvidersByPropDevAndProf',
      getEstados: 'incidencias/getStatusTypes',
      getterVisita: 'incidencias/getVisita',
      getterSuboficios: 'incidencias/getSuboficios',
      getterPredefinedIncidencesByProfession: 'incidencias/getPredefinedIncidencesByProfession',
      getterComplaintTypes: 'incidencias/getComplaintTypes',
      getterComplaintTypesByIncidence: 'incidencias/getComplaintTypesByIncidence',
      getterComplaintTypesByIncidenceComplete: 'incidencias/getComplaintTypesByIncidenceComplete',
      getterOrderTypes: 'incidencias/getOrderTypes',
      getterResponsables: 'incidencias/getResponsables',
      getterLocalizaciones: 'incidencias/getLocations',
      getConfiguracion: 'configuracion/getConfiguracion',
      getterOficios: 'incidencias/getOficios',
      getterUrgencias: 'incidencias/getUrgencias',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      rolProveedor: 'login/rolProveedor',
      idubapi: 'login/idubapi'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    noEvaluado: {
      get () {
        return (this.incidencia.evaluado == '1' || this.incidencia.evaluado == true) ? false : true
      },
      set (val) {
        this.incidencia.evaluado = val ? '0' : '1'
      }
    },
    getTraduccionEstado () {
      var estado = this.getEstados.find(obj => 
        obj.code == this.incidencia.codigoEstado
      )
      if ( estado !== undefined)
        return estado.translates[this.usuario.idioma]
      return  this.incidencia.estado;
    },
    getTraduccionTipo () {
      var tipo = this.tiposSolicitud.find(obj => 
        obj.codigoTipoSolicitud == this.incidencia.codigoTipoSolicitud
      )
      if ( tipo !== undefined)
        return tipo.translates[this.usuario.idioma]
      return  this.incidencia.tipoSolicitud;
    },
    origenAltaComprobado () {
      if(this.incidencia.origenAlta === undefined) return null
      if(this.incidencia.origenAlta === 'WEB') {
        return this.incidencia.origenAlta
      } else if (this.incidencia.origenAlta.includes('CUPE_')) {
        return 'Prinex'
      } else if (this.incidencia.origenAlta === 'Posventa') {
        return 'APP'
      } else if (this.incidencia.origenAlta === 'SIC') {
        return 'Portal del Cliente'
      } else {
        return null
      }
    },
    ocultarProveedorHoras () {
      return this.getConfiguracion.ocultarProveedorHoras
    },
    ocultarResponsable () {
      return this.getConfiguracion.ocultarResponsable
    },
    oficios () {
      return this.getterOficios
    },
    suboficios () {
      return this.getterSuboficios
    },
    tiposDeParte() {
        return this.getterOrderTypes
    },
    tiposDeReclamacion() {
      return this.getterComplaintTypes

    },
    incidenciasPredefinidas() {
        return this.getterPredefinedIncidencesByProfession
    },
    permitirAsignarPromocionesProveedor() {
      return this.getConfiguracion.permitirAsignarPromocionesProveedor
    },
    permisosExtraProveedor() {
      // Sólo se permitirá modificar el oficio y la promoción de la incidencia si está en estado pendiente o en proceso.
      var codEstadosPermisosExtraProveedor = [10,20]
    
      // Se comprobará los permisosExtraProveedor siempre y cuando el proveedor no tenga activado el check de acceso a todas las incidencias
      if ( this.accesoTodasIncidencias() ) {
        return false
      }
      else if ( this.rolProveedor && this.getConfiguracion.PV_PERMISOS_EXTRA_PROVEEDOR && codEstadosPermisosExtraProveedor.includes(parseInt(this.incidencia.codigoEstado)) ) {
        return true
      }
      return false
    },
    localizaciones() {
      if(this.incidencia.estanciaId === null) return this.getterLocalizaciones
      var localizacionIncidencia = this.getterLocalizaciones.find(obj => {
        obj.id === this.incidencia.estanciaId
      })
      if(localizacionIncidencia === undefined ) {
        var localizacionesCopia = this.getterLocalizaciones.map(o => ({...o}))
        localizacionesCopia.push({
          id: this.incidencia.estanciaId,
          name: this.incidencia.estancia,
          code: null,
          disabled: true
        })
        return localizacionesCopia
      } else {
        return this.getterLocalizaciones
      }
    },
    localization () {
      return this.$t('verIncidencia.datosIncidencia')
    },
    responsables () {
      return this.getterResponsables.map(x => {
        return {
          ...x,
          nombreCompleto: x.nombre + ' ' + x.apellidos
        }
      })
    },
    camposObligatorios () {
      return this.getConfiguracion.camposObligatorios
    },
    proveedores () {
      var objetoProveedores = this.getProvidersByPropDevAndProf.map(x => {
        return {
          ...x,
          nombreCompleto: x.code + ' - ' + x.name
        }
      })

      if(this.incidencia.proveedorId === null) return objetoProveedores

      var proveedorIncidencia = objetoProveedores.find(obj => {
        obj.id === this.incidencia.estanciaId
      })
      if(proveedorIncidencia === undefined ) {
        var proveedoresCopia = objetoProveedores.map(o => ({...o}))
        proveedoresCopia.push({
          id: this.incidencia.proveedorId,
          name: this.incidencia.proveedor,
          code: this.incidencia.codigoProveedor,
          nombreCompleto: this.incidencia.codigoProveedor + ' - ' + this.incidencia.proveedor,
          disabled: true
        })
        return proveedoresCopia
      } else {
        return objetoProveedores
      }
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    reabierta () {
      return this.incidencia.reabierta === '1'
    },
    reincidente () {
      return this.incidencia.reincidente === '1'
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getLocalizaciones: 'incidencias/getLocalizaciones',
      getOrderTypes: 'incidencias/getOrderTypes',
      getComplaintTypes: 'incidencias/getComplaintTypes',
      getResponsables: 'incidencias/getResponsables', // works
      getUrgencias: 'incidencias/getUrgencias',
      getOficios: 'incidencias/getOficios',
      getSuboficios: 'incidencias/getSuboficios',
      getComplaintTypesByIncidence: 'incidencias/getComplaintTypesByIncidence',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',
      getStatusTypes: 'incidencias/getStatusTypes',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      getPredefinedIncidencesByProfession: 'incidencias/getPredefinedIncidencesByProfession',
      updateIncidenceStatus: 'incidencias/updateIncidenceStatus',
      updateIncidenceType: 'incidencias/updateIncidenceType',
      checkProviderHasPromotions: 'gestion/checkProviderHasPromotions'
    }),
    changeOficio() {
      this.updateCambiado(true); 
      this.vaciaSubOficio(); 
      this.vaciaIncidenciaPredefinida();
      if ( !this.rolProveedor || this.rolProveedor && !this.permisosExtraProveedor )
      {
        this.vaciaProveedor(); 
      }
    },
    esInmuebleEspecial () {
      if(this.incidencia.inmuebleEspecialPromocionId) {
        return true
      } else {
        return false
      }
    },
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma]
      } else {
        return item.name || item.description || item.text || ''
      }
    },
    accesoTodasIncidencias() {
      return this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ACCESO_TODAS_INCIDENCIAS == 1 ? true : false
    },
    permitirModificarEstado () {
      if ( this.rolProveedor ) {
        if ( this.permitirAsignarPromocionesProveedor && this.accesoTodasIncidencias() ) {
          return false
        }
        else {
          return true
        }
      }
      if ( this.rolCliente ) {
        return false
      }
      else {
        return true
      }
    },
    resetAssociatedFields () {
      this.incidencia.oficioId = null
      this.incidencia.suboficioId = null
      this.incidencia.estanciaId = null
      this.incidencia.incidenciaPredefinidaId = null
    },
    marcarReincidente () {
      this.incidencia.reincidente = (this.incidencia.reincidente === '1') ? this.incidencia.reincidente = '0' : this.incidencia.reincidente = '1'
    },
    updateCambiado (val) {
      this.$emit('cambiado', val)
    },
    async reabrirIncidencia(val) {
      this.incidencia.reabierta = val
      if(val) {
        var hoy = new Date();
        var dd = hoy.getDate();
        var mm = hoy.getMonth()+1;
        var yyyy = hoy.getFullYear();
        this.incidencia.fechaReapertura = yyyy + "-" + mm + "-" + dd

      }
      else {
        this.incidencia.fechaReapertura = null
      }
    },
    async loadData () {
      this.comprobar = false
      const loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        const items = {
          professionId: this.incidencia.oficioId,
          propertyDevelopmentId: this.incidencia.promocionId
        }
        await Promise.all[
          this.getComplaintTypesByIncidence(this.incidencia.id)
            .then(()=> {
              // es una promise, hay que esperar a su vuelta
              this.incidencia.complaint = this.getterComplaintTypesByIncidenceComplete.map(x => {
                return x.tipoReclamacionId
              })
              this.cargandoReclamaciones = false
            }),
          this.getLocalizaciones(this.incidencia.tipoInmuebleId),
          this.getOrderTypes(),
          this.getResponsables(),
          this.getComplaintTypes(),
          this.getUrgencias(),
          ( this.rolProveedor && this.permisosExtraProveedor) ? this.getOficios({providerId: this.incidencia.proveedorId, promotionId: this.incidencia.promocionId}) : this.getOficios(),
          this.getStatusTypes(),
          this.getProvidersByPropertyDevAndProfession(items),
          this.getPredefinedIncidencesByProfession({professionId: this.incidencia.oficioId, subProfessionId: this.incidencia.suboficioId})
        ]
        this.comprobar = true

        loader.hide()

      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        loader.hide()
      }
    },
    async setNuevoEstado (val) {
      // this.updateCambiado(true)
      this.incidencia.estado = this.getEstados.find(x => x.id === val[0].statusId).translates[this.usuario.idioma]
      this.incidencia.codigoEstado = this.getEstados.find(x => x.id === val[0].statusId).code
      this.incidencia.estadoId = this.getEstados.find(x => x.id === val[0].statusId).id
      // this.$emit('cambioEstado', val)

      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        })
        await this.updateIncidenceStatus(val)
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })

        this.$emit('recargarIncidencia')

        this.loader.hide()

        // this.$router.go(0)
        // this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }


    },
    modifyState (item) {
      this.singleItem = []
      this.singleItem.push(item.id)
      this.estadoOrigen = item.codigoEstado
      this.mostrarCambiarEstado = true
    },
    comprobarDeshabilitarCambioTipo() {
      if(this.incidencia.codigoEstado !== '10'){
        return true
      }
      if(this.incidencia.reabierta !== '0'){
        return true
      }
      return false
    },
    cambiarTipoSolicitud(){
      if(this.incidencia.codigoEstado !== '10'){
        this.addAlert({texto: this.$t('soloIncidenciasPendientes'), color: 'error'})
        return
      }
      this.solicitudTipo = this.incidencia
      this.dialogCambiarTipo = true
    },
    async setNuevoTipo (val) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        })
        await this.updateIncidenceType(val)

        this.$emit('recargarIncidencia')

        this.loader.hide()

        // await this.loadData()
        // await this.loadConfiguracion()
        
        // this.incidencia.codigoTipoSolicitud = val.codigoTipoSolicitud
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
        this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    comprobarObligatorio (text) {
      if (this.camposObligatorios) {
        return this.camposObligatorios.some(x => x === text)
      }
      return false
    },
    textoCampoComprobarObligatorio (texto, tipo) {
      return texto + (this.comprobarObligatorio(tipo) ? '*' : '')
    },
    validar () {
      return this.$emit('validar', this.$refs.formIncidencia.validate())
    },
    vaciaProveedor () {
      this.incidencia.proveedorId = null
    },
    vaciaIncidenciaPredefinida () {
      this.incidencia.incidenciaPredefinidaId = null
    },
    vaciaSubOficio () {
      this.incidencia.suboficioId = null
    }
  },
  watch: {
    'incidencia.oficioId': function () {
      if (!this.incidencia.oficioId) {
        this.incidencia.suboficioId = null
      }
      this.getSuboficios(this.incidencia.oficioId)
      this.getPredefinedIncidencesByProfession({professionId: this.incidencia.oficioId, subProfessionId: this.incidencia.suboficioId})
      // this.incidencia.proveedorId = null
      const items = {
        professionId: this.incidencia.oficioId,
        propertyDevelopmentId: this.incidencia.promocionId
      }
      if ( !this.rolProveedor || this.rolProveedor && !this.permisosExtraProveedor ) {
        this.getProvidersByPropertyDevAndProfession(items)
      }
    },
    'incidencia.suboficioId': function () {
      this.getPredefinedIncidencesByProfession({professionId: this.incidencia.oficioId, subProfessionId: this.incidencia.suboficioId})
    },
    'incidencia.horas': function () {
      this.updateCambiado(true)
    },
    incidencia: async function () {
      if (this.incidencia) {
        await this.loadData()
        await this.loadConfiguracion()
      }
    },
    selectedComplaints: function () {
      this.incidencia.complaint = this.selectedComplaints[0]
    },
    'incidencia.fechaAviso': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaNotificacionFinPrevisto': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaRespuestaObra': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaFinPrevisto': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaNotificacionFinReal': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaFinReal': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaReapertura': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaNotificacionRechazo': function () {
      this.updateCambiado(true)
    },
    'incidencia.fechaRevision': function () {
      this.updateCambiado(true)
    }
    /*
    Está cambiando el valor nada más cargar la página de esos 4 campos a null
    'incidencia.codigoTipoSolicitud': function () {
      this.incidencia.oficioId = null
      this.incidencia.suboficioId = null
      this.incidencia.estanciaId = null
      this.incidencia.incidenciaPredefinidaId = null
    } */
  }
}
</script>
